import React, { useEffect } from 'react';
import { useContext as useUsersContext } from 'components/Users/Context';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import { Outlet } from 'react-router-dom';
import Header from './Header';

import ChangeEmailStep from './ChangeEmailStep';
import PayBalanceStep from './PayBalanceStep';

export default function Index() {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUsers } = useUsersContext();

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
  }, []);

  if (stateUsers.user === null) {
    return (
      <div className="content pt-5 pb-5">
        <LoadingPlaceholder text="Loading..." />
      </div>
    );
  }

  return (
    <div className="content">
      <Header />

      {stateUsers.user.attributes.is_need_change_email && (
      <section>
        <ChangeEmailStep />
      </section>
      )}

      <section>
        <PayBalanceStep />
      </section>
      <Outlet />
    </div>
  );
}
